<template>
  <md-card-actions>
    <md-button class="md-primary md-sm" @click="backToQuoteItems()">
      <span class="md-label">
        <md-icon class="material-icons">keyboard_backspace</md-icon> </span
      >View other Quotes
    </md-button>
    <status-button
      :statusId="3"
      :classColour="quoteStatus(3).colour"
      icon="check"
      :text="quoteStatus(3).name"
      :visible="setVisibility(3)"
      :role="200"
      @change-status="changeStatus"
    ></status-button>
    <status-button
      :statusId="7"
      :classColour="quoteStatus(7).colour"
      icon="close"
      :text="quoteStatus(7).name"
      :visible="setVisibility(7)"
      :role="200"
      @change-status="changeStatus"
    ></status-button>
  </md-card-actions>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "quote-actions",
  computed: {
    ...mapGetters({
      quote: "quote/quote",
      quoteStatus: "quote/getQuoteStatus",
      quoteIcon: "quote/icon"
    })
  },
  methods: {
    changeStatus(statusId) {
      this.$emit("change-status", statusId);
    },
    reissueQuote() {
      this.$router.push({
        name: "Reissue Quote",
        params: { quoteId: this.$route.params.quoteId }
      });
    },
    backToQuoteItems() {
      this.$router.push({
        name: this.quoteStatus(this.quote.quoteStatus).list
      });
    },
    setVisibility(statusId) {
      switch (statusId) {
        case 1:
          return this.quote.quoteStatus > 5;
        case 2:
          return this.quote.quoteStatus === 1;
        case 3:
          return this.quote.quoteStatus === 2;
        case 4:
          return this.quote.quoteStatus === 3;
        case 5:
          return this.quote.quoteStatus === 4;
        case 6:
          return this.quote.quoteStatus == 1;
        case 7:
          return this.quote.quoteStatus == 2;
      }
    }
  }
};
</script>

<style></style>
